import styled from 'styled-components';

// W3C recommended solution for accessible link text https://www.w3.org/TR/2012/NOTE-WCAG20-TECHS-20120103/C7
export default styled.span`
  height: 1px;
  width: 1px;
  position: absolute;
  overflow: hidden;
  top: -10px;
`;
